import codes from "../../UserJourney/UserJourneyMap";

const totalRiskLevel = 4;

const ranges = {
    inactive: {
        key: "inactive",
        label: codes.answers.PaiScores.inactive
    },
    moderatelyInactive: {
        key: "moderatelyInactive",
        label: codes.answers.PaiScores.moderatelyInactive
    },
    moderatelyActive: {
        key: "moderatelyActive",
        label: codes.answers.PaiScores.moderatelyActive
    },
    active: {
        key: "active",
        label: codes.answers.PaiScores.active
    }
};

// Ordered highest risk first, matching every other guideline in the system. Result screens
// render this array top to bottom, so this order is what the user sees on the card.
const SisuActivityGuidelineDefinition = [
    {
        key: "inactive",
        label: codes.answers.PaiScores.inactive,
        rangeInfo: "",
        ranges,
        riskLevel: 4 / (totalRiskLevel + 1)
    },
    {
        key: "moderatelyInactive",
        label: codes.answers.PaiScores.moderatelyInactive,
        rangeInfo: "",
        ranges,
        riskLevel: 3 / (totalRiskLevel + 1)
    },
    {
        key: "moderatelyActive",
        label: codes.answers.PaiScores.moderatelyActive,
        rangeInfo: "",
        ranges,
        riskLevel: 2 / (totalRiskLevel + 1)
    },
    {
        key: "active",
        label: codes.answers.PaiScores.active,
        rangeInfo: "",
        ranges,
        riskLevel: 1 / (totalRiskLevel + 1)
    }
];

/**
 * Finds the guideline for the given score
 * @param paiScore - The PAI score string to match
 * @returns {object|null} The matching guideline definition or null if not found
 */
function GetGuideline(paiScore) {
    // Debug logging to help identify mismatches
    console.log("[SiSU-Activity] GetGuideline called with paiScore:", paiScore);
    console.log("[SiSU-Activity] Available guideline labels:", SisuActivityGuidelineDefinition.map(def => def.label));

    // Try exact match first
    let guideline = SisuActivityGuidelineDefinition.find(def => def.label === paiScore);

    if (guideline) {
        console.log("[SiSU-Activity] Found exact match:", guideline);
        return guideline;
    }

    // Try case-insensitive match as fallback
    guideline = SisuActivityGuidelineDefinition.find(
        def => def.label && def.label.toLowerCase() === paiScore?.toLowerCase()
    );

    if (guideline) {
        console.log("[SiSU-Activity] Found case-insensitive match:", guideline);
        return guideline;
    }

    // Log error and return null
    console.error("[SiSU-Activity] GetGuideline: No matching guideline found for paiScore:", paiScore);
    console.error("[SiSU-Activity] Available labels:", SisuActivityGuidelineDefinition.map(def => def.label));
    return null;
}

const RiskName = "ACTIVITY";
const RiskCode = "ACTIVITY";
const GuidelineName = "SiSu Activity Guideline";
const GuidelineCode = "SISU_ACTIVITY";

export default { GetGuideline, RiskName, RiskCode, GuidelineName, GuidelineCode, SisuActivityGuidelineDefinition };
